import { FC } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

import ProductContextPanel from "./index";
import { tokens } from "@/tokens";

type Props = {
  open: boolean;
  onClose: () => void;
  productId: string | null;
};

/**
 * Wraps ProductContextPanel in a Dialog so any page with a product list
 * (customs-erp products tab, future product-catalogue page, etc.) can
 * expose attachment + chat linking without embedding the panel inline.
 */
export const ProductContextDialog: FC<Props> = ({
  open,
  onClose,
  productId,
}) => (
  <Dialog open={open && !!productId} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle sx={{ pb: 1 }}>
      <Stack>
        <Typography variant="h6">Files & Chats</Typography>
        <Typography
          variant="caption"
          sx={{ color: tokens.text.muted }}
        >
          Upload product specs, photos, or description docs and attach
          related chats. Both feed into per-product tariff-engineering
          research.
        </Typography>
      </Stack>
    </DialogTitle>
    <DialogContent dividers>
      <Box sx={{ pt: 1 }}>
        {productId && <ProductContextPanel productId={productId} compact />}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Done</Button>
    </DialogActions>
  </Dialog>
);

export default ProductContextDialog;
